import type { CustomizationMachineInput, Input } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export const getFetchCustomizationDataInput: CustomizationMachineInput<
  Input
> = (args) => {
  const {
    productSlug,
    restaurantSlug,
    ingredientAssetVersion,
    lineItemId,
    isDelivery,
  } = args.context;

  return {
    productSlug,
    restaurantSlug,
    ingredientAssetVersion,
    lineItemId,
    isDelivery,
  };
};
